import {
  useEffect,
  useRef,
} from "react";

import { createPortal } from "react-dom";

import "./POSSessionConfirm.css";


export default function POSSessionConfirm({
  companyName,
  primaryColor,
  onConfirm,
  onCancel,
}) {
  const dialogRef = useRef(null);
  const cancelRef = useRef(null);

  useEffect(() => {
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;

    document.body.style.overflow = "hidden";
    cancelRef.current?.focus();

    function handleKeyDown(event) {
      if (event.key === "Escape") {
        event.preventDefault();
        onCancel();
        return;
      }

      if (event.key !== "Tab") return;

      const buttons = Array.from(
        dialogRef.current?.querySelectorAll(
          "button:not([disabled])"
        ) || []
      );

      const first = buttons[0];
      const last = buttons[buttons.length - 1];

      if (!first || !last) return;

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    }

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener("keydown", handleKeyDown);

      if (previousFocus?.isConnected) {
        previousFocus.focus();
      }
    };
  }, [onCancel]);

  return createPortal(
    <div
      className="pos-session-confirm-backdrop"
      style={{
        "--session-brand": primaryColor || "#334155",
      }}
    >
      <section
        ref={dialogRef}
        className="pos-session-confirm"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="session-confirm-title"
        aria-describedby="session-confirm-description"
      >
        <button
          type="button"
          className="pos-session-confirm-close"
          onClick={onCancel}
          aria-label="Cancelar y cerrar"
        >
          ×
        </button>

        <div className="pos-session-confirm-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.7"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <rect x="3" y="3" width="18" height="12" rx="2" />
            <path d="M8 21h8M12 15v6" />
            <path d="M9 9h6m-2-2 2 2-2 2" />
          </svg>
        </div>

        <span className="pos-session-confirm-company">
          {companyName}
        </span>

        <h2 id="session-confirm-title">
          Ya tienes una sesión activa
        </h2>

        <p id="session-confirm-description">
          Tu usuario está conectado en otra ventana,
          navegador o computador. Puedes cerrar esa sesión
          y continuar desde aquí.
        </p>

        <div className="pos-session-confirm-details">
          <div>
            <span aria-hidden="true">✓</span>
            <p>
              <strong>Tu operación se conserva</strong>
              La caja abierta y las ventas registradas
              permanecerán guardadas.
            </p>
          </div>

          <div>
            <span aria-hidden="true">!</span>
            <p>
              <strong>Revisa lo que no has guardado</strong>
              El carrito y los datos sin guardar de la otra
              sesión no se trasladarán.
            </p>
          </div>
        </div>

        <div className="pos-session-confirm-actions">
          <button
            ref={cancelRef}
            type="button"
            className="pos-session-confirm-cancel"
            onClick={onCancel}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="pos-session-confirm-continue"
            onClick={onConfirm}
          >
            Cerrar sesión anterior e ingresar aquí
          </button>
        </div>

        <p className="pos-session-confirm-footer">
          La sesión anterior perderá el acceso al POS.
        </p>
      </section>
    </div>,
    document.body
  );
}